import { breakpoints, Text, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const FooterWrapper = styled.div`
  box-shadow: 0px -1px 2px 0px rgba(71, 71, 71, 0.04),
    0px -2px 4px 0px rgba(71, 71, 71, 0.08);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  padding: 1rem 1.25rem;

  @media (min-width: ${breakpoints.md}) {
    position: relative;
  }
`;

export const PolicyText = styled(Text)`
  color: ${theme.color.text.secondary};
  text-align: center;
`;

export const ProgramAndPrivacyLink = styled.a`
  color: ${theme.color.text.secondary};
  text-decoration: underline;
`;

export const NotinoClub = styled.a`
  ${theme.typography.labelRegular400};
  color: ${theme.color.text.inverse};

  flex: 0 0 auto;

  &:hover {
    color: ${theme.color.text.inverse};
  }
`;
